import { useThemeContext } from "../../context/ThemeContext";

import styles from "./Button.module.scss";

import { ButtonProps } from "./types";

export function Button({
  buttonType = "link",
  buttonText,
  onClick,
}: ButtonProps) {
  const theme = useThemeContext();
  const buttonContent = buttonText || "more info →";

  return buttonType === "primary" ? (
    <button
      onClick={onClick}
      className={styles.primaryBtn}
      style={{ background: theme.acc }}
    >
      {buttonContent}
    </button>
  ) : buttonType === "ghost" ? (
    <button
      onClick={onClick}
      className={styles.ghostBtn}
      style={{
        background: theme.card,
        color: theme.fg,
        border: `1px solid ${theme.rule}`,
      }}
    >
      {buttonContent}
    </button>
  ) : (
    <button
      onClick={onClick}
      className={styles.linkBtn}
      style={{ color: theme.acc }}
    >
      {buttonContent}
    </button>
  );
}
